import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/auth/RouteGuards";
import PublicLayout from "@/components/layout/PublicLayout";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUsers from "@/pages/AdminUsers";
import Profile from "@/pages/Profile";
import NewQuestion from "@/pages/NewQuestion";
import MyRequests from "@/pages/MyRequests";
import RequestDetail from "@/pages/RequestDetail";
import AdminRequests from "@/pages/AdminRequests";
import AdminRequestDetail from "@/pages/AdminRequestDetail";
import Resources from "@/pages/Resources";
import HowItWorks from "@/pages/HowItWorks";
import AboutUs from "@/pages/AboutUs";
import Faqs from "@/pages/Faqs";
import RipartizioneSpese from "@/pages/RipartizioneSpese";
import MaggioranzeAssembleari from "@/pages/MaggioranzeAssembleari";
import AssembleaStraordinaria from "@/pages/AssembleaStraordinaria";
import CodiceCivile from "@/pages/CodiceCivile";
import AdminCategories from "@/pages/AdminCategories";
import AdminArticles from "@/pages/AdminArticles";
import AdminArticleEditor from "@/pages/AdminArticleEditor";
import AdminResources from "@/pages/AdminResources";
import AdminFaqs from "@/pages/AdminFaqs";
import AdminSynonyms from "@/pages/AdminSynonyms";
import AdminSearchAnalytics from "@/pages/AdminSearchAnalytics";
import AdminAnalyticsUsage from "@/pages/AdminAnalyticsUsage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import CookiePolicy from "@/pages/CookiePolicy";

function NotFound() {
    return (
        <div className="mx-auto max-w-lg px-4 py-24 text-center">
            <div className="text-xs uppercase tracking-widest text-primary font-semibold">Errore 404</div>
            <h1 className="mt-2 font-serif text-4xl font-semibold">Pagina non trovata</h1>
            <p className="mt-3 text-muted-foreground">La pagina che stai cercando non esiste o non è ancora disponibile.</p>
            <Link to="/" className="mt-6 inline-block text-primary font-semibold hover:underline" data-testid="notfound-home-link">Torna alla home →</Link>
        </div>
    );
}

const P = ({ children, admin }) => <ProtectedRoute adminOnly={admin}>{children}</ProtectedRoute>;

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ScrollToTop />
                <Routes>
                    <Route element={<PublicLayout />}>
                        <Route index element={<Home />} />
                        <Route path="login" element={<Login />} />
                        <Route path="registrati" element={<Register />} />
                        <Route path="verifica-email" element={<VerifyEmail />} />
                        <Route path="recupera-password" element={<ForgotPassword />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                        <Route path="come-funziona" element={<HowItWorks />} />
                        <Route path="chi-siamo" element={<AboutUs />} />
                        <Route path="faq" element={<Faqs />} />
                        <Route path="faq/ripartizione-spese" element={<RipartizioneSpese />} />
                        <Route path="faq/maggioranze-assembleari" element={<MaggioranzeAssembleari />} />
                        <Route path="faq/assemblea-straordinaria" element={<AssembleaStraordinaria />} />
                        <Route path="codice-civile" element={<CodiceCivile />} />
                        <Route path="risorse" element={<Resources />} />
                        <Route path="privacy" element={<PrivacyPolicy />} />
                        <Route path="termini" element={<Terms />} />
                        <Route path="cookie" element={<CookiePolicy />} />
                        <Route path="dashboard" element={<P><UserDashboard /></P>} />
                        <Route path="dashboard/nuova" element={<P><NewQuestion /></P>} />
                        <Route path="dashboard/richieste" element={<P><MyRequests /></P>} />
                        <Route path="dashboard/richieste/:id" element={<P><RequestDetail /></P>} />
                        <Route path="profilo" element={<P><Profile /></P>} />
                        <Route path="admin" element={<P admin><AdminDashboard /></P>} />
                        <Route path="admin/utenti" element={<P admin><AdminUsers /></P>} />
                        <Route path="admin/richieste" element={<P admin><AdminRequests /></P>} />
                        <Route path="admin/richieste/:id" element={<P admin><AdminRequestDetail /></P>} />
                        <Route path="admin/categorie" element={<P admin><AdminCategories /></P>} />
                        <Route path="admin/articoli" element={<P admin><AdminArticles /></P>} />
                        <Route path="admin/articoli/nuovo" element={<P admin><AdminArticleEditor /></P>} />
                        <Route path="admin/articoli/:id" element={<P admin><AdminArticleEditor /></P>} />
                        <Route path="admin/risorse" element={<P admin><AdminResources /></P>} />
                        <Route path="admin/faq" element={<P admin><AdminFaqs /></P>} />
                        <Route path="admin/faq/sinonimi" element={<P admin><AdminSynonyms /></P>} />
                        <Route path="admin/faq/analitica" element={<P admin><AdminSearchAnalytics /></P>} />
                        <Route path="admin/statistiche" element={<P admin><AdminAnalyticsUsage /></P>} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
                <Toaster position="top-right" richColors closeButton />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
